import { render } from "./CustomURLUpload.vue?vue&type=template&id=14a72c23&scoped=true"
import script from "./CustomURLUpload.vue?vue&type=script&lang=js"
export * from "./CustomURLUpload.vue?vue&type=script&lang=js"

import "./CustomURLUpload.vue?vue&type=style&index=0&id=14a72c23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a72c23"]])

export default __exports__